// extracted by css-extract-rspack-plugin
export default {"footerSocial":"footer-social--a5wdjM6yXcYt0c14","spin":"spin--iEl1OjBAu8do9Xgw"};